import { spacing } from '$tablet-app/src/app/theme';
import React from 'react';
import { StyleSheet, Text, View } from 'react-native';
import { RobotDevice } from '../../../types';

interface RobotConnectionStatusDisplayProps {
  robot: RobotDevice;
  height?: number;
}

export const RobotConnectionStatusDisplay = (
  props: RobotConnectionStatusDisplayProps
) => {
  const { robot } = props;

  const connectionStatus =
    robot.websocketConnection?.connectionStatus ?? 'disconnected';

  const color =
    connectionStatus === 'connected'
      ? 'green'
      : connectionStatus === 'connecting'
      ? 'orange'
      : 'red';

  const size = props.height ?? 25;
  const internalSize = size * 0.8;

  return (
    <View style={[styles.container, { height: size, borderRadius: size / 2 }]}>
      <View
        style={[
          styles.statusIcon,
          {
            width: internalSize,
            height: internalSize,
            borderRadius: internalSize / 2,
            backgroundColor: color,
          },
        ]}
      />
      <Text style={styles.statusText} adjustsFontSizeToFit numberOfLines={1}>
        {`${connectionStatus}`}
      </Text>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    backgroundColor: 'lightcyan',
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'center',
    marginTop: 'auto',
    marginBottom: spacing[1],
  },
  statusIcon: {
    marginLeft: spacing[1],
  },
  statusText: {
    fontSize: 16,
    color: 'black',
    textAlign: 'center',
    flex: 1,
    textTransform: 'capitalize',
  },
});
